import axios from 'axios';

export const getCameraVisibility = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_HOST}/cameras/visibility`);
        return response.data;
    } catch (error) {
        console.error('Error fetching camera visibility:', error);
        // On failure keep the camera visible - a network blip should not black it out.
        return { ok: false, hidden: false, hiddenUntil: null, message: '' };
    }
};
